import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import icon from "../../images/icon/magic.png";
import about1 from "../../images/icon/airdrop.png";
import about2 from "../../images/icon/people.png";
import about3 from "../../images/icon/microphone.png";

const About = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section
      id="about"
      className="about pb-50"
     
    >
      <div className="about-wrapper sec-bg pos-rel pb-40 pt-40">
        <div className="container">
          <div className="sec-title--two text-center">
           
            <Fade
              direction="down"
              triggerOnce={"false"}
              duration={1500}
              delay={9}
            >
              <h2
                className="title wow fadeInDown"
                data-wow-delay="150ms"
                data-wow-duration="600ms"
              >
                Simple, Safe & Fast Money Transfers
              </h2>
            </Fade>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-12 mt-50 text-center d-flex justify-content-center">
              <div className="about-right w-100">
                <div className="d-flex flex-column flex-md-row justify-content-between gap-5">
                  {/* Item 1 */}
                  <div className="my-xb-item--holder text-start d-flex align-items-start p-4  col-lg-4">
                    <div className="d-flex flex-column align-items-center">
                      <img
                        src={require("../../images/icon/instatnt_alert.png")}
                        alt="Alert Icon"
                        className="me-3"
                        style={{ width: "50px", height: "50px" }}
                      />
                      <h3 className="xb-item--title col-lg-10 pb-10 pt-10 m-2 text-center">
                        Stay Notified Instantly
                      </h3>
                      <p className="xb-item--content mb-0 text-center">
                        We’ll send you instant alerts every time your money is
                        sent or received — no guessing, no waiting.
                      </p>
                    </div>
                  </div>

                  {/* Item 2 */}
                  <div className="my-xb-item--holder text-start d-flex align-items-start p-4 ">
                    <div className="d-flex flex-column align-items-center">
                      <img
                        src={require("../../images/icon/Exchange_Updates.png")}
                        alt="Rate Icon"
                        className="me-3"
                        style={{ width: "50px", height: "50px" }}
                      />
                      <h3 className="xb-item--title col-lg-10 pb-10 pt-10 m-2 text-center">
                        Know the Best Rates
                      </h3>
                      <p className="xb-item--content mb-0 text-center">
                        We show you live exchange rates, so you always know the
                        best time to send money.
                      </p>
                    </div>
                  </div>

                  {/* Item 3 */}
                  <div className="my-xb-item--holder text-start d-flex align-items-start p-4 ">
                    <div className="d-flex flex-column align-items-center">
                      <img
                        src={require("../../images/icon/Confirmation.png")}
                        alt="Success Icon"
                        className="me-3"
                        style={{ width: "50px", height: "50px" }}
                      />
                      <h3 className="xb-item--title col-lg-10 pb-10 pt-10 m-2 text-center">
                        Know When It’s Done
                      </h3>
                      <p className="xb-item--content mb-0 text-center">
                        Get a confirmation message the moment your money reaches
                        its destination. Simple and stress-free.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
